/**
 * Full-page navigation seam.
 *
 * All direct window.location WRITES in app code go through this object
 * instead of touching window.location directly. window.location is
 * [LegacyUnforgeable] in Chrome — it cannot be replaced, redefined, or
 * spied — so a real location write during a Karma spec navigates the test
 * context iframe and silently restarts the entire suite (issue #453). The
 * test bootstrap (src/test.ts) stubs these methods once, which both keeps
 * the suite alive and makes hard navigations assertable in specs.
 *
 * Reading window.location (href, origin, search, ...) is safe and does not
 * need this seam.
 */
export const hardNavigation = {
  /** window.location.href = url — full-page navigation, leaves the SPA. */
  navigate(url: string): void {
    window.location.href = url;
  },

  /** window.location.reload() — full reload of the current URL. */
  reload(): void {
    window.location.reload();
  },

  /** Frame-busting: point the top window at this frame's own URL. */
  bustFrame(): void {
    window.top.location.href = window.self.location.href;
  },
};
